import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@ui/button';
import { ResponsiveImage } from '@web/molecules';
import { Eyebrow } from '@web/atoms';
import { useReporter } from '../../reporter';
import { ctaButtonClicked } from './events';
import {
  Content,
  ButtonContainer,
  ImageContainer,
  StyledSplitScreenPromo,
  ButtonWrapper,
} from './styles.js';

export const SplitScreenPromo = ({
  contentBgColor,
  imageBgColor,
  fontColor = 'text.primary',
  image,
  link,
  imageFirst = false,
  content,
  eyebrow,
}) => {
  const reporter = useReporter();
  return (
    <StyledSplitScreenPromo>
      <Content $fontColor={fontColor} $bgColor={contentBgColor}>
        {eyebrow && <Eyebrow textAlign="center">{eyebrow}</Eyebrow>}
        {content}
        {link && (
          <ButtonContainer>
            <ButtonWrapper $bgColor={contentBgColor}>
              <LinkButton
                variant={link.variant}
                href={link.target}
                headerText={link.headerText}
                onClick={() =>
                  reporter.tag(
                    ctaButtonClicked(
                      link.text,
                      content?.[0]?.props?.content?.heading_text,
                    ),
                  )
                }
              >
                {link.text}
              </LinkButton>
            </ButtonWrapper>
          </ButtonContainer>
        )}
      </Content>
      <ImageContainer $bgColor={imageBgColor} imageFirst={imageFirst}>
        {image?.src && (
          <ResponsiveImage
            {...image}
            sizes={'(max-width: 768px) 100vw, 50vw'}
          />
        )}
      </ImageContainer>
    </StyledSplitScreenPromo>
  );
};

SplitScreenPromo.displayName = 'SplitScreenPromo';

SplitScreenPromo.propTypes = {
  contentBgColor: PropTypes.string,
  fontColor: PropTypes.string,
  image: PropTypes.object,
  imageBgColor: PropTypes.string,
  imageFirst: PropTypes.bool,
  link: PropTypes.shape({
    target: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  content: PropTypes.node,
  eyebrow: PropTypes.string,
};
